import { useRef, useMemo } from 'react';
import { colors, colors_axis_right } from '../utils/colors';

export interface DataKey {
    key: string;
    color: string;
}

interface AxisVariable {
    id: number;
    titulo: string;
    values: string[];
}

export const useDataKeyDualAxis = (
    data: any[],
    ejeY2Variable?: AxisVariable
) => {
    const leftColorMapRef = useRef<Map<string, string>>(new Map());
    const rightColorMapRef = useRef<Map<string, string>>(new Map());
    const leftColorIndexRef = useRef<number>(0);
    const rightColorIndexRef = useRef<number>(0);

    const dataKey = useMemo(() => {
        if (!data?.length) return { left: [], right: [] };

        const keys = Object.keys(data[0]).filter((k) => k !== "name");

        let rightKeys: string[] = [];

        if (ejeY2Variable) {
            rightKeys = ejeY2Variable.values?.length > 0
                ? keys.filter((k) => ejeY2Variable.values.includes(k))
                : [ejeY2Variable.titulo];
        }

        const leftKeys = keys.filter((k) => !rightKeys.includes(k));

        const leftData = leftKeys.map((key) => {
            if (leftColorMapRef.current.has(key)) {
                return { key, color: leftColorMapRef.current.get(key)! };
            }

            const color = colors[leftColorIndexRef.current % colors.length];
            leftColorMapRef.current.set(key, color);
            leftColorIndexRef.current++;

            return { key, color };
        });

        const rightData = rightKeys.map((key) => {
            if (rightColorMapRef.current.has(key)) {
                return { key, color: rightColorMapRef.current.get(key)! };
            }

            const color = colors_axis_right[rightColorIndexRef.current % colors_axis_right.length];
            rightColorMapRef.current.set(key, color);
            rightColorIndexRef.current++;

            return { key, color };
        });

        return {
            left: leftData,
            right: rightData,
        };
    }, [data, ejeY2Variable]);

    return { dataKey };
};